import styled from "styled-components";

export const SegmentationContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 400px;
`;
